export async function wait(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function toCamelCase(str: string): string {
  // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/naming-convention
  return str.toLowerCase().replace(/[_.-](\w|$)/g, (_, x) => x.toUpperCase());
}
